module.exports = __webpack_public_path__ + "media/images/restaurant/areas/okinawa-f5c3cd0659d81c49afd5b0c14c604094.png";